import { KratosOutcome } from '@/enums/kratos'
import { KRATOS_WHOAMI_PATH, classifyKratosResponse } from '@/libs/kratos'
import { useAppStore } from '@/stores/app'
import { useFetchStore } from '@/stores/fetch'
import type { IKratosSession } from '@/types/Kratos'

/**
 * "Is anybody signed in" is a Kratos `whoami` call: the session lives in an HttpOnly cookie.
 * `whoami.required_aal: aal1` means it answers for a password-only session too. A positive
 * answer is cached for the page's lifetime (`force` re-asks); a negative one is not.
 */
export const whoami = async (force = false): Promise<IKratosSession | undefined> => {
    const appStore = useAppStore()
    if (!force && appStore.session) return appStore.session

    const { kratosRequest } = useFetchStore()
    const raw      = await kratosRequest(KRATOS_WHOAMI_PATH)
    const response = classifyKratosResponse<IKratosSession>(raw.status, raw.data)

    if (response.kind === KratosOutcome.Ok && response.data?.id) {
        appStore.setSession(response.data)
        return response.data
    }

    appStore.setLogout()
    return undefined
}

/** A full document navigation — every continuation that leaves the SPA goes through here. */
export const browserNavigate = (url: string): void => {
    window.location.assign(url)
}
